/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BackendApiCapexsService } from './services/backend-api-capexs.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [BackendApiCapexsService, ApiConfiguration],
})
export class BackendApiMonitoringMetadoorInvestModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BackendApiMonitoringMetadoorInvestModule> {
    return {
      ngModule: BackendApiMonitoringMetadoorInvestModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: BackendApiMonitoringMetadoorInvestModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error(
        'BackendApiMonitoringMetadoorInvestModule is already loaded. Import in your base AppModule only.',
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
